module.exports = __webpack_public_path__ + "img/pic_11.1aa16ed5.jpg";